import { defineComponent as _defineComponent } from 'vue'
import UiButton from 'JS/components/UiButton.vue';
import { createPrebuiltHeaderPromoAttributes, createPrebuiltHeaderSubcatPromoAttributes } from '../header-promo-attrs';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';
import { PrebuiltCategoryHeaderData } from 'JS/dxp/types/widgets/prebuilt-header-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'PetHeader',
  props: {
    data: null
  },
  setup(__props: any) {



const title = "Blain's Farm & Fleet Pet Supplies Shop";
const subtitle = "Shop online or in-store for a variety of affordable pet supplies. Your convenient one-stop shop for dog, cat and small animal supplies.";

const image = "url('/assets/images/dxp/prebuilt-header/Pet-Hero.jpg')";

const gaDataAttributes = createPrebuiltHeaderPromoAttributes(title, subtitle);


return { __sfc: true,title, subtitle, image, gaDataAttributes, UiButton, createPrebuiltHeaderSubcatPromoAttributes, cssVarsToStyleString }
}

})